import { Field, ID, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import { StatusEnum } from '../../base/StatusEnum'
import type { CustomerAndCompany } from '../../customer'

@InputType()
export class UpdateCompanyStatusWithSubCompaniesArgs extends ActionArgs {
  @Field(() => ID)
  _id: string

  @Field(() => StatusEnum)
  status: StatusEnum
}

export interface IUpdateCompanyStatusWithSubCompanies
  extends IAction<CustomerAndCompany, UpdateCompanyStatusWithSubCompaniesArgs> {}
